import { TextInput } from "components/atoms";
import { MultipleCheckbox } from "components/molecules/OnboardingFormAnswer/MultipleCheckbox";
import { RadioInput } from "components/molecules/OnboardingFormAnswer/RadioInput";
import { OnboardingFormQuestion } from "components/molecules/OnboardingFormQuestion";
import { TextAreaInput } from "components/molecules/OnboardingFormAnswer/TextAreaInput";
import { QuestionType } from "utils/types/OnboardingForms";
import "./index.scss";

interface IProps {
  questions: QuestionType[] | undefined;
  // answer: any;
  allAnswers: any;
  onAnswerChange: (id: string, value: any, type?: string) => void;
}

export const RendererProfileInfo = ({
  questions,
  // answer,
  allAnswers,
  onAnswerChange,
}: IProps) => {
  return questions ? (
    <>
      <div className="question-and-answers-wrapper">
        <OnboardingFormQuestion question={`1. ${questions[0].Label}`} />
        <div className="onb-form-answer-wrapper">
          <TextInput
            value={allAnswers[questions[0].FieldName]}
            onChange={(e) =>
              onAnswerChange(questions[0].FieldName, e.target.value)
            }
            style={
              questions[0].DataType === "number" ||
              questions[0].DataType === "Integer"
                ? "input-number-custom-style"
                : "input-text-custom-style"
            }
            type={questions[0].DataType}
          />
        </div>
      </div>
      <div className="question-and-answers-wrapper">
        <OnboardingFormQuestion question={`2. ${questions[1].Label}`} />
        <div className="onb-form-answer-wrapper">
          <TextInput
            value={allAnswers[questions[1].FieldName]}
            onChange={(e) =>
              onAnswerChange(questions[1].FieldName, e.target.value)
            }
            style={
              questions[1].DataType === "number" ||
              questions[1].DataType === "Integer"
                ? "input-number-custom-style"
                : "input-text-custom-style"
            }
            type={questions[1].DataType}
          />
        </div>
      </div>
      <div className="question-and-answers-wrapper">
        <OnboardingFormQuestion question={`3. ${questions[2].Label}`} />
        <div className="onb-form-answer-wrapper">
          <MultipleCheckbox
            options={questions[2].Choices}
            value={allAnswers[questions[2].FieldName]}
            onChange={(value: any) =>
              onAnswerChange(
                questions[2].FieldName,
                value,
                questions[2].DataType
              )
            }
          />
        </div>
      </div>
      <div className="question-and-answers-wrapper">
        <OnboardingFormQuestion question={`4. ${questions[3].Label}`} />
        <div className="onb-form-answer-wrapper">
          <RadioInput
            options={questions[3].Choices}
            // value={typeof answer === "string" ? answer : answer?.answer}
            value={allAnswers[questions[3].FieldName]}
            name={questions[3].FieldName}
            onChange={(value: any) =>
              onAnswerChange(questions[3].FieldName, value)
            }
          />
        </div>
      </div>
      {allAnswers[questions[3].FieldName] === true &&
      questions[3].SubQuestions &&
      questions[3].SubQuestions[0] ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`4a. ${questions[3].SubQuestions[0].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[3].SubQuestions[0].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={allAnswers[questions[3].SubQuestions[0].FieldName]}
              name={questions[3].SubQuestions[0].FieldName}
              onChange={(value: any) =>
                questions[3].SubQuestions !== undefined &&
                onAnswerChange(questions[3].SubQuestions[0].FieldName, value)
              }
            />
            {questions[3].SubQuestions &&
            allAnswers[questions[3].SubQuestions[0].FieldName] === "Other" ? (
              <TextAreaInput
                fieldName={"OtherTimeAccommodation"}
                answer={allAnswers["OtherTimeAccommodation"]}
                maxLength={30}
                onAnswerChange={onAnswerChange}
              />
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="question-and-answers-wrapper">
        <OnboardingFormQuestion question={`5. ${questions[4].Label}`} />
        <div className="onb-form-answer-wrapper">
          <RadioInput
            options={questions[4].Choices}
            // value={typeof answer === "string" ? answer : answer?.answer}
            value={allAnswers[questions[4].FieldName]}
            name={questions[4].FieldName}
            onChange={(value: any) =>
              onAnswerChange(questions[4].FieldName, value)
            }
          />
          {allAnswers[questions[4].FieldName] === true &&
          questions[4].SubQuestions &&
          questions[4].SubQuestions[0] ? (
            <TextAreaInput
              fieldName={questions[4].SubQuestions[0].FieldName}
              answer={allAnswers[questions[4].SubQuestions[0].FieldName]}
              maxLength={100}
              onAnswerChange={onAnswerChange}
            />
          ) : null}
        </div>
      </div>
    </>
  ) : null;
};
